import Vue from 'vue'
import { mapGetters } from 'vuex'

Vue.mixin({
  computed: {
    ...mapGetters({
      storeCurrency: 'store/currency',
      storeCountry: 'store/country'
    }),
    locale () {
      return this.$i18n.locale
    },
    pageData () {
      if (typeof this.$route.meta === 'object' && this.$route.meta !== null && Object.keys(this.$route.meta).length) {
        return this.$route.meta
      }
      return this.$attrs
    }
  },
  methods: {
    b64DecodeUnicode (str) {
      return Buffer.from(str, 'base64').toString()
    },
    debounce (func, wait, immediate) {
      let timeout
      return function () {
        const context = this
        const args = arguments
        const later = function () {
          timeout = null
          if (!immediate) func.apply(context, args)
        }
        const callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) func.apply(context, args)
      }
    },
    throttleFunction (func, limit) {
      let lastFunc
      let lastRan
      return function () {
        const context = this
        const args = arguments
        if (!lastRan) {
          func.apply(context, args)
          lastRan = Date.now()
        } else {
          clearTimeout(lastFunc)
          lastFunc = setTimeout(function () {
            if ((Date.now() - lastRan) >= limit) {
              func.apply(context, args)
              lastRan = Date.now()
            }
          }, limit - (Date.now() - lastRan))
        }
      }
    },
    slugify (string) {
      const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
      const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnooooooooprrsssssttuuuuuuuuuwxyyzzz------'
      const p = new RegExp(a.split('').join('|'), 'g')

      return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w-]+/g, '') // Remove all non-word characters
        .replace(/--+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
    },
    getTitle (parts = null, includeSuffix = true) {
      const titleSuffixVeryShort = 'SunGod'
      const titleSuffixShort = this.$tr('SunGod. Performance Sunglasses and Goggles.')
      const titleSuffixLong = this.$tr('SunGod. Performance Sunglasses and Goggles for Bike, Run, Snow & Adventure')

      if (!parts) return titleSuffixLong

      if (typeof parts === 'string') parts = [parts]
      parts = parts.filter(part => part)
      const title = parts.join(' | ')
      if (title.length > 40) return `${this.$tr(title)} | ${titleSuffixVeryShort}`
      return `${this.$tr(title)} | ${titleSuffixShort}`
    },
    getEnglishTitle (parts = null, includeSuffix = true) {
      const titleSuffixVeryShort = 'SunGod'
      const titleSuffixShort = 'SunGod. Performance Sunglasses and Goggles.'
      const titleSuffixLong = 'SunGod. Performance Sunglasses and Goggles for Bike, Run, Snow & Adventure'

      if (!parts) return titleSuffixLong

      if (typeof parts === 'string') parts = [parts]
      parts = parts.filter(part => part)
      const title = parts.join(' | ')
      if (title.length > 40) return `${title} | ${titleSuffixVeryShort}`
      return `${title} | ${titleSuffixShort}`
    },
    getDescription (description, ...args) {
      return [{
        hid: 'description',
        name: 'description',
        content: this.$tr(description, ...args)
      }, {
        hid: 'og:description',
        property: 'og:description',
        content: this.$tr(description, ...args)
      }]
    },
    getEnglishDescription (description) {
      return [{
        hid: 'description',
        name: 'description',
        content: description
      }, {
        hid: 'og:description',
        property: 'og:description',
        content: description
      }]
    },
    truncString (str, length, useWordBoundary = true) {
      if (str.length <= length) { return str }
      const subString = str.substr(0, length - 1) // the original check
      return (useWordBoundary
        ? subString.substr(0, subString.lastIndexOf(' '))
        : subString) + '…'
    }
  }
})